
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import VerticalTimeline from "./pages/Timeline";
import About from "./pages/About";
import Media from './pages/Media';
import Footer from './pages/Footer';
import Specialities from "./pages/Specialties";
import Treatments from "./pages/Treatments";
// import About from "./pages/About";
// import Contact from "./pages/Contact";
// import NotFound from "./pages/NotFound";

const AppRoutes = () => {
  return (
<>

    <Router>
    <Home></Home>
      <Routes>
        <Route path="/" element={<About />} />
        <Route path="/specialities" element={<Specialities/>}/>
        <Route path="/media" element={<Media />} />
        <Route path="/about" element={<VerticalTimeline/>}/>
        <Route path="/treatments" element={<Treatments/>}></Route>
        {/* <Route path='/footer' element={<Footer/>}/> */}
        {/* <Route path="/about" element={<VerticalTimeline />} />  */}
        {/* <Route path="*" element={<NotFound />} />  404 Page */}
      </Routes>
      <Footer></Footer>
    </Router>

    </>
  );
};

export default AppRoutes;
